<div class="h-full flex  justify-center items-center">
  <mat-card class="flex justify-center items-center w-[550px] h-[450px] rounded-2xl bg-[#f7f7f7]">
    <form [formGroup]="emailFormGroup" (ngSubmit)="onSubmit()" class="flex flex-col justify-center items-center h-full w-80">
      <img alt="Mol Limo" src="../../../assets/figures/logo.svg" class="mb-6"/>
      <p class="mat-headline font-bold mb-4">Limo admin</p>
      <mat-form-field appearance="standard" class="self-stretch" hideRequiredMarker>
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" (input)="clearCredentialsIncorrect()" type="email" autocomplete="email">
        <mat-error *ngIf="emailFormGroup.get('email')?.hasError('email') && !emailFormGroup.get('email')?.hasError('required')">
          Az email cím formátuma nem megfelelő
        </mat-error>
        <mat-error *ngIf="emailFormGroup.get('email')?.hasError('required')">
          Kötelező mező
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="standard" class="self-stretch mb-6" hideRequiredMarker>
        <mat-label>Jelszó</mat-label>
        <input matInput formControlName="password" (input)="clearCredentialsIncorrect()" [type]="passwordVisible ? 'text' : 'password'" autocomplete="current-password">
        <mat-icon matSuffix (click)="togglePasswordVisible()" class="material-icons-outlined translate-y-2">
          {{passwordVisible ? 'visibility' : 'visibility_off'}}
        </mat-icon>
        <mat-error *ngIf="emailFormGroup.get('password')?.hasError('required')">
          Kötelező mező
        </mat-error>
      </mat-form-field>
      <button mat-flat-button color="primary" class="mol-btn-lg self-stretch" [disabled]="areCredentialsIncorrect()">Belépés</button>
    </form>
  </mat-card>
</div>
